import {tv, type VariantProps} from 'tailwind-variants'
import type {HgIconType} from '~/design-system/hg/components'

export type IconTextItem = {
  iconType: HgIconType
  text: string
}

export type SplitImageInnerHeroProps = HgHeroSplitImageProps & {
  classNames?: {
    gridSlot: string
    heading: string
    headingContainer: string
  }
  headingContainerRef: React.RefObject<HTMLDivElement | null>
  containerRef: React.RefObject<HTMLDivElement | null>
}

export const splitImageVariants = tv({
  slots: {
    imageWrapper:
      'col-span-full lg:col-span-8 lg:col-start-9 [&_img]:rounded-xl [&_video]:rounded-xl',
    contentWrapper: 'flex flex-col',
  },
  variants: {
    size: {
      long: '',
      short: {
        imageWrapper: 'xl:col-span-6 xl:col-start-9',
      },
    },
    hasAdditionalContent: {
      true: {
        contentWrapper: 'h-full justify-between',
      },
      false: {
        contentWrapper: '',
      },
    },
  },
})

export type HgHeroSplitImageProps = {
  type: 'splitImage'
  logoAsset: React.ReactNode
  size: 'long' | 'short'
  assetFourFiveRatio: React.ReactNode
  assetOneOneRatio?: React.ReactNode
  assetThreeTwoRatio?: React.ReactNode
  additionalContent?: React.ReactNode
  heroBullets?: IconTextItem[]
} & VariantProps<typeof splitImageVariants>
